import { defineComponent as k, computed as o, useAttrs as n, inject as r, ref as C, watch as g, onMounted as B, createElementBlock as c, openBlock as d, normalizeClass as u, createVNode as N, unref as T, mergeProps as A, withCtx as _, createElementVNode as f, createCommentVNode as E, toDisplayString as I, renderSlot as V } from "vue";
import "@ds/components/Badge";
import { RevButtonBase as K } from "@ds/components/ButtonBase";
import { variantKey as R, setActiveTabKey as S } from "@ds/components/Tabs";
import { useTrackedListeners as $ } from "../../composables/useTrackedListeners.js";
import { tw as t } from "../../utils/tailwind.js";
const j = {
  key: 0,
  class: "ml-8 align-middle"
}, G = /* @__PURE__ */ k({
  name: "RevTabItem",
  inheritAttrs: !1,
  __name: "TabItem",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: {}
  },
  emits: ["click"],
  setup(m, { emit: p }) {
    const a = m, v = p, b = o(() => {
      const { listeners: e } = $(a);
      return {
        ...n(),
        ...e,
        class: void 0
      };
    }), l = r(R), i = r(S), s = C(null), h = o(() => [
      t`relative flex h-56 list-none items-center`,
      l === "fixed" && t`flex-1`,
      l === "flexible" && t`whitespace-nowrap`
    ]), x = o(() => [
      t`focus-visible-outline-inset-hi flex h-full items-center border-none bg-transparent p-0 text-center no-underline motion-safe:transition motion-safe:duration-200`,
      !a.active && !a.disabled && t`text-action-default-low cursor-pointer hover:bg-static-default-min-hover hover:text-action-default-low-hover`,
      a.active && !a.disabled && t`text-action-default-low-pressed pointer-events-none cursor-default`,
      a.active && t`body-1-bold`,
      !a.active && t`body-1`,
      a.disabled && t`text-action-default-low-disabled cursor-not-allowed`,
      l === "fixed" && t`flex-1 px-12`,
      l === "flexible" && t`overflow-hidden text-ellipsis`
    ]), w = o(() => [
      n().class,
      l === "fixed" && t`line-clamp-2 grow`
    ]), y = (e) => {
      a.disabled || v("click", e);
    };
    return g(
      () => a.active,
      async (e) => {
        e && i && s.value && i(s.value);
      }
    ), B(async () => {
      a.active && i && s.value && i(s.value);
    }), (e, z) => (d(), c("li", {
      ref_key: "tab",
      ref: s,
      class: u(h.value)
    }, [
      N(T(K), A(b.value, {
        "aria-selected": e.active,
        class: x.value,
        disabled: e.disabled,
        title: e.label,
        onClick: y
      }), {
        default: _(() => [
          f("span", {
            class: u(w.value)
          }, [
            f("span", null, I(e.label), 1),
            e.$slots.default ? (d(), c("span", j, [
              V(e.$slots, "default")
            ])) : E("", !0)
          ], 2)
        ]),
        _: 3
      }, 16, ["aria-selected", "class", "disabled", "title"])
    ], 2));
  }
});
export {
  G as default
};
